import { useMutation } from '@apollo/client';
import { loader } from 'graphql.macro';

const addReviewerMutation = loader('./addReviewer.graphql');
const deleteReviewerMutation = loader('./deleteReviewer.graphql');
const updateReviewerMutation = loader('./updateReviewer.graphql');

export const useUserMutations = () => {
  const [addReviewerMut] = useMutation(addReviewerMutation);
  const [deleteReviewerMut] = useMutation(deleteReviewerMutation);
  const [updateReviewerMut] = useMutation(updateReviewerMutation);

  const addReviewer = async ({
    userId,
    notes,
    status,
    reviewableId,
    reviewableType,
    parentId,
    onComplete = () => {},
  }) => {
    await addReviewerMut({
      variables: {
        userId,
        notes,
        status,
        reviewableId,
        reviewableType,
        parentId,
      },
    }).then(() => onComplete());
  };

  const deleteReviewer = async ({ reviewerId, onComplete = () => {} }) => {
    await deleteReviewerMut({ variables: { reviewerId } }).then(() =>
      onComplete(),
    );
  };
  const updateReviewer = async ({
    reviewerId,
    notes,
    status,
    onComplete = () => {},
  }) => {
    await updateReviewerMut({ variables: { reviewerId, notes, status } }).then(
      () => onComplete(),
    );
  };

  return { addReviewer, deleteReviewer, updateReviewer };
};
